<h2 class="h4 mt-0 mb-1">Reset Password?</h2>
<p [tcColor]="'#8f8f90'">Reset with new password</p>

<reset-form></reset-form>
